import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { Location } from '@angular/common';
import { Meta, Title } from '@angular/platform-browser';
import { switchMap } from 'rxjs/operators';
import { CPage } from 'src/app/models/page.models/page.model';
import { PageService } from 'src/app/services/page.service';
import { API_ServerAddress } from 'src/app/MyAppCommonConfig';

@Component({
  selector: 'pageDetails',
  templateUrl: 'page.component.html'
})
export class PageComponent implements OnInit {
  ngOnInit(): void {
    this.route.paramMap
      .pipe(
        switchMap((params: ParamMap) => {
          this.id = Number(params.get('id'));
          return this.GetPage();
        })
      )
      .subscribe((data: CPage) => {
        this.page = data;
        this.SetPageMetaData(data);

        if (data.fImageAddressHighQuality) {
          this.pageWithPictureMode = true;
        } else {
          this.pageWithPictureMode = false;
        }
      });
  }

  ApiServiceAddress: string;
  page: CPage = new CPage();
  id: number;
  pageWithPictureMode: boolean = false;

  constructor(
    private pageService: PageService,
    private route: ActivatedRoute,
    private location: Location,
    private titleService: Title,
    private metaService: Meta
  ) {
    this.ApiServiceAddress = API_ServerAddress;
    this.id = +this.route.snapshot.paramMap.get('id');
  }

  GetPage() {
    return this.pageService.GetById(this.id);
  }

  goBack(): void {
    this.location.back();
  }

  SetPageMetaData(model: CPage) {
    this.titleService.setTitle(model.fSubject);
    this.metaService.updateTag({
      name: 'description',
      content: model.fMetaDescription
    });
    this.metaService.updateTag({
      name: 'keywords',
      content: model.fMetaKeywords
    });
  }
}
